import { DistAngleToolsComponent } from './../components/attribute-view/dist-angle-tools/dist-angle-tools.component';
import { SpreadToolsComponent } from './../components/attribute-view/spread-tools/spread-tools.component';
import { SnapToolsComponent } from './../components/attribute-view/snap-tools/snap-tools.component';
import { IconStackIconComponent } from './../components/button/icon-stack/icon-stack-icon/icon-stack-icon.component';
import { CustomSymbolDisplayComponent } from './../components/classification-view/custom-symbol-display/custom-symbol-display.component';
import { UnicodeService } from './../services/unicode.service';
import { UnicodeRangeSelectorComponent } from './../components/dialogs/custom-symbol-dialog/unicode-range-selector/unicode-range-selector.component';
import { CharacterMapComponent } from './../components/dialogs/custom-symbol-dialog/character-map/character-map.component';
import { CustomSymbolDialogService } from './../components/dialogs/custom-symbol-dialog/custom-symbol-dialog.service';
import { QRCodeModule } from 'angularx-qrcode';
import { FramingComponent } from './../components/framing/framing.component';
import { SymbolSelectorComponent } from './../components/classification-view/symbol-selector/symbol-selector.component';
import { ViewStackViewUnencapsulatedComponent } from './../components/view-stack/view-stack-view-unencapsulated/view-stack-view-unencapsulated.component';
import { PopupSelectInputComponent } from './../components/popup-select-input/popup-select-input.component';
import { ModalSelectDialogComponent, ModalSelectDialogEntryComponent } from './../components/dialogs/modal-select-dialog/modal-select-dialog.component';
import { NodragDirective } from './../model/directives/nodrag.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionGroupComponent } from '../components/action-group/action-group.component';
import { IconButtonComponent } from '../components/icon-button/icon-button.component';
import { ToolActionsComponent } from '../components/tool-actions/tool-actions.component';
import { ToolSetComponent } from '../components/tool-set/tool-set.component';
import { ViewStackComponent } from '../components/view-stack/view-stack.component';
import { ModalMessagerComponent } from '../modal-messager/modal-messager.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewStackViewComponent } from '../components/view-stack/view-stack-view/view-stack-view.component';
import { PanelSetComponent } from '../components/panel-set/panel-set.component';
import { AngularSplitModule } from 'angular-split';
import { TreeModule } from '@circlon/angular-tree-component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgxBootstrapSliderModule } from 'ngx-bootstrap-slider';
import { ToggleSwitchComponent } from '../components/toggle-switch/toggle-switch.component';
import { ButtonGroupComponent } from '../components/button-group/button-group.component';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { FontSelectorComponent } from '../components/font-selector/font-selector.component';
import { ColorPickerInputComponent } from '../components/color-picker-input/color-picker-input.component';
import { AlignmentInputComponent } from '../components/alignment-input/alignment-input.component';
import { XYOffsetInputComponent } from '../components/xyoffset-input/xyoffset-input.component';
import { FontSizeInputComponent } from '../components/font-size-input/font-size-input.component';
import { LabelStyleButtonComponent } from '../components/dialogs/label-style-dialog/label-style-button/label-style-button.component';
import { Grid9PositionComponent } from '../components/grid9-position/grid9-position.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { SynchButtonComponent } from '../components/synch-button/synch-button.component';
import { LayerGalleryComponent } from '../components/dialogs/layer-selection-dialog/layer-gallery/layer-gallery.component';
import { ResultGalleryButtonComponent } from '../components/result-gallery-button/result-gallery-button.component';
import { GalleryButtonComponent } from '../components/gallery-button/gallery-button.component';
import { ImageCapturePanelComponent } from '../components/image-capture-panel/image-capture-panel.component';
import { DateOfValueComponent } from '../components/criteria/date-of-value/date-of-value.component';
import { DateWithinValueComponent } from '../components/criteria/date-within-value/date-within-value.component';
import { DateFirstDowComponent } from '../components/criteria/date-first-dow/date-first-dow.component';
import { DateIsAComponent } from '../components/criteria/date-is-a/date-is-a.component';
import { DateDaysValComponent } from '../components/criteria/date-days-val/date-days-val.component';
import { DateMonthsValComponent } from '../components/criteria/date-months-val/date-months-val.component';
import { DateValComponent } from '../components/criteria/date-val/date-val.component';
import { DateBufferComponent } from '../components/criteria/date-buffer/date-buffer.component';
import { DateKindComponent } from '../components/criteria/date-kind/date-kind.component';
import { DateKindsComponent } from '../components/criteria/date-kinds/date-kinds.component';
import { TextValComponent } from '../components/criteria/text-val/text-val.component';
import { NumberValComponent } from '../components/criteria/number-val/number-val.component';
import { PlusMinusSelComponent } from '../components/plus-minus-sel/plus-minus-sel.component';
import { CurrencySelComponent } from '../components/currency-sel/currency-sel.component';
import { NegativeNumbersSelComponent } from '../components/att-casting-view/formats/negative-numbers-sel/negative-numbers-sel.component';
import { FractionalValuesSelComponent } from '../components/att-casting-view/formats/fractional-values-sel/fractional-values-sel.component';
import { CastingFormatsSelComponent } from '../components/att-casting-view/formats/casting-formats-sel/casting-formats-sel.component';
import { NegativeFormatsSelComponent } from '../components/att-casting-view/formats/negative-formats-sel/negative-formats-sel.component';
import { CurrencyFormatsSelComponent } from '../components/currency-formats-sel/currency-formats-sel.component';
import { CastingTypeFormatsSelComponent } from '../components/att-casting-view/formats/casting-type-formats-sel/casting-type-formats-sel.component';
import { CastingLinkComponent } from '../components/att-casting-view/formats/casting-link/casting-link.component';
import { CastingTextComponent } from '../components/att-casting-view/formats/casting-text/casting-text.component';
import { CleanHTMLPipe } from '../model/pipes/clean-html.pipe';
import { CastingBooleanComponent } from '../components/att-casting-view/formats/casting-boolean/casting-boolean.component';
import { NumberGeneralInputComponent } from '../components/attribute-view/inputs/number-general-input/number-general-input.component';
import { NumberHexInputComponent } from '../components/attribute-view/inputs/number-hex-input/number-hex-input.component';
import { NumberBinaryInputComponent } from '../components/attribute-view/inputs/number-binary-input/number-binary-input.component';
import { NumberPercentageInputComponent } from '../components/attribute-view/inputs/number-percentage-input/number-percentage-input.component';
import { NumberFractionInputComponent } from '../components/attribute-view/inputs/number-fraction-input/number-fraction-input.component';
import { NumberPhoneInputComponent } from '../components/attribute-view/inputs/number-phone-input/number-phone-input.component';
import { NumberCurrencyInputComponent } from '../components/attribute-view/inputs/number-currency-input/number-currency-input.component';
import { NumberZipcodeInputComponent } from '../components/attribute-view/inputs/number-zipcode-input/number-zipcode-input.component';
import { BooleanInputComponent } from '../components/attribute-view/inputs/boolean-input/boolean-input.component';
import { TextInputComponent } from '../components/attribute-view/inputs/text-input/text-input.component';
import { DatetimeInputComponent } from '../components/attribute-view/inputs/datetime-input/datetime-input.component';
import { TimeInputComponent } from '../components/attribute-view/inputs/time-input/time-input.component';
import { LinkInputComponent } from '../components/attribute-view/inputs/link-input/link-input.component';
import { InputComponent } from '../components/attribute-view/inputs/input/input.component';
import { NumberOctalInputComponent } from '../components/attribute-view/inputs/number-octal-input/number-octal-input.component';
import { AddAttributeDialogComponent, AddAttributeDialogEntryComponent } from '../components/dialogs/add-attribute-dialog/add-attribute-dialog.component';
import { GeolocPartComponent } from '../components/attribute-view/inputs/number-geoloc-part/number-geoloc-part.component';
import { CastingGeolocPartSelComponent } from '../components/att-casting-view/formats/casting-geoloc-part-sel/casting-geoloc-part-sel.component';
import { CastingMediaSelComponent } from '../components/att-casting-view/formats/casting-media-sel/casting-media-sel.component';
import { MediaInputComponent } from '../components/attribute-view/inputs/media-input/media-input.component';
import { AttEditorComponent } from '../components/attribute-view/att-editor/att-editor.component';
import { VertexToolsComponent } from '../components/attribute-view/vertex-tools/vertex-tools.component';
import { ProjectionInfoComponent } from '../components/projection-info/projection-info.component';
import { ProjectionUploaderComponent } from '../components/projection-uploader/projection-uploader.component';
import { ProjectionTypeaheadComponent } from '../components/projection-typeahead/projection-typeahead.component';
import { ProjectionSelectorComponent } from '../components/projection-selector/projection-selector.component';
import { ProjectionByCodeComponent } from '../components/projection-by-code/projection-by-code.component';
import { UserBadgeComponent } from '../components/dmi/user-badge/user-badge.component';
import { ButtonComponent } from '../components/button/button.component';
import { ButtonIconComponent } from '../components/button/button-icon/button-icon.component';
import { ButtonProxyComponent } from '../components/button/button-proxy/button-proxy.component';
import { ButtonSetComponent } from '../components/button/button-set/button-set.component';
import { LegacyPaletteComponent } from '../components/dialogs/color-picker-dialog/legacy-palette/legacy-palette.component';
import { SlTreeComponent } from '../components/sl-tree/sl-tree.component';
import { CustomSymbolDialogComponent, CustomSymbolDialogEntryComponent } from '../components/dialogs/custom-symbol-dialog/custom-symbol-dialog.component';
import { CharacterSwatchComponent } from '../components/dialogs/custom-symbol-dialog/character-swatch/character-swatch.component';
import { CharacterInspectorComponent } from '../components/dialogs/custom-symbol-dialog/character-inspector/charcter-inspector.component';
import { IconStackComponent } from '../components/button/icon-stack/icon-stack.component';
import { IconStackButtonComponent } from '../components/button/icon-stack-button/icon-stack-button.component';
import { AngleViewComponent } from '../components/angle-view/angle-view.component';
import { AngleEditorComponent } from '../components/angle-editor/angle-editor.component';
import { DistanceEditorComponent } from '../components/distance-editor/distance-editor.component';
import { SnapLayerViewComponent } from '../components/layer-view/snap-layer-view/snap-layer-view.component';

@NgModule({
  declarations: [
    ActionGroupComponent,
    IconButtonComponent,
    ToolActionsComponent,
    ToolSetComponent,
    ViewStackComponent,
    ViewStackViewComponent,
    ModalMessagerComponent,
    PanelSetComponent,
    ToggleSwitchComponent,
    ButtonGroupComponent,
    FontSelectorComponent,
    ColorPickerInputComponent,
    AlignmentInputComponent,
    XYOffsetInputComponent,
    FontSizeInputComponent,
    LabelStyleButtonComponent,
    Grid9PositionComponent,
    SynchButtonComponent,
    LayerGalleryComponent,
    ResultGalleryButtonComponent,
    GalleryButtonComponent,
    ImageCapturePanelComponent,
    DateOfValueComponent,
    DateWithinValueComponent,
    DateFirstDowComponent,
    DateIsAComponent,
    DateDaysValComponent,
    DateMonthsValComponent,
    DateValComponent,
    DateBufferComponent,
    DateKindComponent,
    DateKindsComponent,
    TextValComponent,
    NumberValComponent,
    CastingFormatsSelComponent,
    PlusMinusSelComponent,
    CurrencySelComponent,
    NegativeNumbersSelComponent,
    FractionalValuesSelComponent,
    NegativeFormatsSelComponent,
    CurrencyFormatsSelComponent,
    CastingTypeFormatsSelComponent,
    CastingLinkComponent,
    CastingTextComponent,
    CastingMediaSelComponent,
    CastingBooleanComponent,
    CastingGeolocPartSelComponent,
    CleanHTMLPipe,
    NumberGeneralInputComponent,
    NumberHexInputComponent,
    NumberBinaryInputComponent,
    NumberPercentageInputComponent,
    NumberFractionInputComponent,
    NumberPhoneInputComponent,
    NumberCurrencyInputComponent,
    NumberZipcodeInputComponent,
    BooleanInputComponent,
    TextInputComponent,
    LinkInputComponent,
    DatetimeInputComponent,
    TimeInputComponent,
    LinkInputComponent,
    InputComponent,
    NumberOctalInputComponent,
    AddAttributeDialogComponent,
    AddAttributeDialogEntryComponent,
    ModalSelectDialogComponent,
    ModalSelectDialogEntryComponent,
    CustomSymbolDialogEntryComponent,
    CustomSymbolDialogComponent,
    GeolocPartComponent,
    MediaInputComponent,
    AttEditorComponent,
    VertexToolsComponent,
    ProjectionInfoComponent,
    ProjectionUploaderComponent,
    ProjectionTypeaheadComponent,
    ProjectionSelectorComponent,
    ProjectionByCodeComponent,
    UserBadgeComponent,
    ButtonComponent,
    ButtonIconComponent,
    ButtonProxyComponent,
    ButtonSetComponent,
    NodragDirective,
    PopupSelectInputComponent,
    LegacyPaletteComponent,
    ViewStackViewUnencapsulatedComponent,
    SymbolSelectorComponent,
    SlTreeComponent,
    FramingComponent,
    CharacterMapComponent,
    CharacterSwatchComponent,
    CharacterInspectorComponent,
    UnicodeRangeSelectorComponent,
    CustomSymbolDisplayComponent,
    IconStackComponent,
    IconStackIconComponent,
    IconStackButtonComponent,
    SnapToolsComponent,
    SpreadToolsComponent,
    DistAngleToolsComponent,
    AngleViewComponent,
    AngleEditorComponent,
    DistanceEditorComponent,
    SnapLayerViewComponent
  ],
  exports: [
    ActionGroupComponent,
    IconButtonComponent,
    ToolActionsComponent,
    ToolSetComponent,
    ViewStackViewComponent,
    ViewStackComponent,
    ViewStackViewUnencapsulatedComponent,
    ModalMessagerComponent,
    NgbModule,
    PanelSetComponent,
    TreeModule,
    UiSwitchModule,
    NgxBootstrapSliderModule,
    ToggleSwitchComponent,
    AngularSplitModule,
    AngularSlickgridModule,
    FontSelectorComponent,
    ColorPickerInputComponent,
    AlignmentInputComponent,
    XYOffsetInputComponent,
    FontSizeInputComponent,
    LabelStyleButtonComponent,
    Grid9PositionComponent,
    SynchButtonComponent,
    CKEditorModule,
    LayerGalleryComponent,
    ResultGalleryButtonComponent,
    GalleryButtonComponent,
    ImageCapturePanelComponent,
    DateOfValueComponent,
    DateWithinValueComponent,
    DateFirstDowComponent,
    DateIsAComponent,
    DateDaysValComponent,
    DateMonthsValComponent,
    DateValComponent,
    DateBufferComponent,
    DateKindComponent,
    DateKindsComponent,
    TextValComponent,
    NumberValComponent,
    CastingFormatsSelComponent,
    PlusMinusSelComponent,
    CurrencySelComponent,
    NegativeNumbersSelComponent,
    FractionalValuesSelComponent,
    NegativeFormatsSelComponent,
    CurrencyFormatsSelComponent,
    CastingTypeFormatsSelComponent,
    CastingLinkComponent,
    CastingTextComponent,
    CastingMediaSelComponent,
    CastingBooleanComponent,
    CastingGeolocPartSelComponent,
    CleanHTMLPipe,
    NumberGeneralInputComponent,
    NumberHexInputComponent,
    NumberBinaryInputComponent,
    NumberOctalInputComponent,
    NumberPercentageInputComponent,
    NumberFractionInputComponent,
    NumberPhoneInputComponent,
    NumberCurrencyInputComponent,
    NumberZipcodeInputComponent,
    BooleanInputComponent,
    TextInputComponent,
    LinkInputComponent,
    DatetimeInputComponent,
    LinkInputComponent,
    GeolocPartComponent,
    MediaInputComponent,
    InputComponent,
    AddAttributeDialogComponent,
    AddAttributeDialogEntryComponent,
    ModalSelectDialogComponent,
    ModalSelectDialogEntryComponent,
    CustomSymbolDialogEntryComponent,
    CustomSymbolDialogComponent,
    AttEditorComponent,
    VertexToolsComponent,
    ProjectionInfoComponent,
    ProjectionUploaderComponent,
    ProjectionTypeaheadComponent,
    ProjectionSelectorComponent,
    ProjectionByCodeComponent,
    UserBadgeComponent,
    ButtonComponent,
    ButtonIconComponent,
    ButtonSetComponent,
    NodragDirective,
    PopupSelectInputComponent,
    LegacyPaletteComponent,
    SymbolSelectorComponent,
    SlTreeComponent,
    FramingComponent,
    QRCodeModule,
    CharacterSwatchComponent,
    CharacterMapComponent,
    CharacterInspectorComponent,
    UnicodeRangeSelectorComponent,
    CustomSymbolDisplayComponent,
    IconStackComponent,
    IconStackIconComponent,
    IconStackButtonComponent,
    SnapToolsComponent,
    SpreadToolsComponent,
    DistAngleToolsComponent,
    AngleViewComponent,
    AngleEditorComponent,
    DistanceEditorComponent,
    SnapLayerViewComponent,
    ButtonGroupComponent
  ],
  providers: [
    UnicodeService
  ],
  imports: [
    CommonModule,
    NgbModule,
    AngularSplitModule.forRoot(),
    TreeModule,
    UiSwitchModule,
    NgxBootstrapSliderModule,
    AngularSlickgridModule.forRoot(),
    CKEditorModule,
    QRCodeModule
  ]
})
export class UiElementsModule { }
